import { render } from "./PermissionCreate.vue?vue&type=template&id=923f45c0&scoped=true"
import script from "./PermissionCreate.vue?vue&type=script&lang=js"
export * from "./PermissionCreate.vue?vue&type=script&lang=js"

import "./PermissionCreate.vue?vue&type=style&index=0&id=923f45c0&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923f45c0"]])

export default __exports__